/**
 * Shadow Tokens (Internal Design System)
 *
 * Custom elevation shadows for the design system.
 * Each level uses two layered shadows for depth.
 */

import { borders } from './borders'
import { colors } from './colors'

const shadowColor = '19, 25, 39'

export const shadows = {
  none: 'none',
  xs: `0 0.125rem 0.25rem -0.125rem rgba(${shadowColor}, 0.12), 0 0.25rem 0.25rem -0.125rem rgba(${shadowColor}, 0.08)`,
  sm: `0 0.25rem 0.375rem -0.25rem rgba(${shadowColor}, 0.12), 0 0.5rem 0.5rem -0.25rem rgba(${shadowColor}, 0.08)`,
  md: `0 0.375rem 0.5rem -0.375rem rgba(${shadowColor}, 0.12), 0 0.5rem 1rem -0.375rem rgba(${shadowColor}, 0.08)`,
  lg: `0 0.375rem 0.75rem -0.375rem rgba(${shadowColor}, 0.12), 0 0.5rem 1.5rem -0.25rem rgba(${shadowColor}, 0.08)`,
  xl: `0 0.375rem 0.875rem -0.375rem rgba(${shadowColor}, 0.12), 0 0.625rem 2rem -0.25rem rgba(${shadowColor}, 0.1)`,
  xxl: `0 0.5rem 1.125rem -0.375rem rgba(${shadowColor}, 0.12), 0 0.75rem 2.625rem -0.25rem rgba(${shadowColor}, 0.12)`,
  huge: `0 0.5rem 1.375rem -0.375rem rgba(${shadowColor}, 0.12), 0 0.875rem 4rem -0.25rem rgba(${shadowColor}, 0.12)`,
  /** Elevated menu/popover shadow — matches Figma elevation spec for overlays */
  menu: `0 1.125rem 5.5rem -0.25rem rgba(${shadowColor}, 0.14), 0 0.5rem 1.75rem -0.375rem rgba(${shadowColor}, 0.12)`,
}

/** Input field shadows — shared across light and dark themes */
export const inputShadows = {
  default: `inset 0 0 0 ${borders.width.thin} ${colors.neutral[300]}`,
  hover: `inset 0 0 0 ${borders.width.medium} ${colors.primary[700]}`,
  focus: `inset 0 0 0 ${borders.width.medium} ${colors.primary[700]}`,
  focusRing: `${borders.width.medium} solid ${colors.primary[100]}`,
  error: `inset 0 0 0 ${borders.width.medium} ${colors.red[600]}`,
  disabled: `inset 0 0 0 ${borders.width.thin} ${colors.neutral[300]}`,
} as const

/**
 * MUI shadows array (25 levels: 0-24)
 * Maps our 7 custom levels across MUI's elevation scale
 */
export const muiShadows: [
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
] = [
  shadows.none, // 0
  shadows.xs, // 1
  shadows.xs, // 2
  shadows.sm, // 3
  shadows.sm, // 4
  shadows.md, // 5
  shadows.md, // 6
  shadows.lg, // 7
  shadows.lg, // 8
  shadows.xl, // 9
  shadows.xl, // 10
  shadows.xl, // 11
  shadows.xxl, // 12
  shadows.xxl, // 13
  shadows.xxl, // 14
  shadows.xxl, // 15
  shadows.huge, // 16
  shadows.huge, // 17
  shadows.huge, // 18
  shadows.huge, // 19
  shadows.huge, // 20
  shadows.huge, // 21
  shadows.huge, // 22
  shadows.huge, // 23
  shadows.huge, // 24
]
